function About(props) {
    return (
        <div className="About">
            We are the HustleCouple!
            Find us on <a href="https://twitter.com/HustleCouple">twitter</a>,
            on <a href="https://patreon.com/HustleCouple">patreon</a>,
            or buy a bowl from us on our <a href="https://e-zdjele.weeblysite.com/">webshop</a>.
        </div>
    )
}

export default About